import React, { Component } from 'react';
import Navbar from '../Navbar'
import { Row, Col, Card, Button, CardHeader, CardBody, Input, Collapse, Badge, InputGroupAddon, InputGroup, InputGroupText } from 'reactstrap';

const { proxy } = require('../../ip_api.config')

class Film_DisplayProductImage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            files: {},
            uploadContent: [],
            itemId: '',
        }
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const itemIdParam = urlParams.get('itemId');
        const idParam = urlParams.get('id');
        if (urlParams && itemIdParam && idParam) {
            let q = JSON.parse(window.atob(idParam))
            let q2 = JSON.parse(window.atob(itemIdParam))
            this.get_productDataById({ itemId: q, itemDesc: '', iBrand1: '', iBrand2: '', iBrand3: '', itemG1: '', itemG3: '' })
            this.get_uploadByItem({ itemId: q2, userId: localStorage.getItem("ID_User") })
        }
    }

    get_productDataById = (searchData) => {
        let url = proxy.server + '/flim/getProductData'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(searchData)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productData]", responseJson)
                switch (responseJson.status) {
                    case 200:
                        this.setState({ productData: responseJson.result })
                        break;
                    default: this.setState({ productData: [] })
                }
            })
    }

    get_uploadByItem = (data) => {
        let url = proxy.server + '/flim/getUploadByItem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson", responseJson)
                switch (responseJson.status) {
                    case 200:
                        let files = {};
                        let itemId = '';
                        let collapseUploadList = [];

                        responseJson.result.forEach(item => {
                            collapseUploadList.push(false)
                            files[`${item.fieldName}`] = (item.inputType === 'textarea') ? "" : [];
                            itemId = item.itemId;
                            item.dataCount = 0;
                        });

                        this.setState({ uploadContent: responseJson.result, files: files, itemId: itemId, collapseUploadList: collapseUploadList })
                        this.get_dataUploadedByItem(data)
                        break;
                    default: this.setState({ uploadContent: [] })
                }
            })
    }

    get_productNameFilter = () => {
        let url = proxy.server + '/flim/getProductNameFilter'
        fetch(url, {
            method: "POST",
            headers: {
            },
            body: {}
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                switch (responseJson.status) {
                    case 200:
                        let arr = []
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.itemId, label: val.itemName })
                        })
                        this.setState({ optionItemId: arr })
                        break;
                    default: this.setState({ optionItemId: [] })
                }
            })
    }

    get_ItemIdFilter = () => {
        let url = proxy.server + '/flim/getItemIdFilter'
        fetch(url, {
            method: "POST",
            headers: {
            },
            body: {}
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_productNameFilter]", responseJson)
                switch (responseJson.status) {
                    case 200:
                        let arr = []
                        responseJson.result.map(function (val, i) {
                            arr.push({ value: val.itemId, label: val.itemName })
                        })
                        this.setState({ optionItemId: arr })
                        break;
                    default: this.setState({ optionItemId: [] })
                }
            })
    }

    get_dataUploadedByItem = (data) => {
        let url = proxy.server + '/flim/getDataUploadedByItem'
        fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json;charset=utf-8"
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then((responseJson) => {
                console.log("responseJson [get_dataUploadedByItem]", responseJson)
                switch (responseJson.status) {
                    case 200:

                        const { files } = this.state;
                        let filesCopy = files;
                        responseJson.result.forEach(item => {
                            for (let key in filesCopy) {
                                if (key === item.fieldName) {
                                    switch (item.inputType) {
                                        case 'file':
                                            item.fileName = item.value.substring((item.value.lastIndexOf('/') + 1));
                                            filesCopy[`${item.fieldName}`].push(item)
                                            break;
                                        case 'textarea':
                                            filesCopy[`${item.fieldName}`] = item.value
                                            break;
                                        case 'text':
                                            filesCopy[`${item.fieldName}`].push({ value: item.value, remark: item.remark })
                                            break;
                                    }
                                }
                            }
                            let uploadContent = this.state.uploadContent.slice();
                            for (let i = 0; i < uploadContent.length; i++) {

                                if (item.typeNo === uploadContent[i].typeNo) {
                                    uploadContent[i].dataCount++;
                                }
                            }
                        });
                        this.setState({ files: filesCopy })


                        break;
                    default:
                }
            })
    }

    renderType = (type, name) => {
        switch (type) {
            case 'textarea':
                return (
                    this.state.files[name] ?
                        <Input type="textarea" value={this.state.files[name]} disabled />
                        : ''
                )
            case 'text':
                return (
                    this.state.files[name].length > 0 &&
                    this.state.files[name].map((val, i) => {
                        return (
                            <div style={{ display: 'flex', marginBottom: '10px' }}>
                                <div className="col-md-6 col-sm-4" id="inputRow" style={{ padding: '0' }}>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>Link</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="text" value={val.value} disabled />
                                    </InputGroup>
                                </div> &nbsp;
                                <div className="col-md-6 col-sm-4" id="inputRow" style={{ padding: '0' }}>
                                    <InputGroup>
                                        <InputGroupAddon addonType="prepend">
                                            <InputGroupText>หมายเหตุ</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type="text" name={name} value={val.remark} disabled />
                                    </InputGroup>
                                </div>
                            </div>
                        )
                    })
                )
            case 'file':
                return (
                    <React.Fragment>
                        {
                            this.state.files[name] && this.state.files[name].map((val, i) => {
                                return (
                                    <div style={{ display: 'flex', margin: '5px' }} key={i}>
                                        <div style={{ flex: '1' }}>
                                            {
                                                val.typeName && val.typeName === 'IMAGE' ?
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <img src={`${proxy.server}/${val.value}`} onClick={() => this.handleDisplayImg(`${proxy.server}/${val.value}`)} style={{ maxHeight: '70px', maxWidth: '70px', width: '70px', height: '70px', objectFit: 'cover', cursor: 'pointer' }} />
                                                        <span style={{ marginLeft: '5px' }}>{val.fileName}</span>
                                                    </div>
                                                    : val.typeName === 'FILE' &&
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        <div style={{ flex: '1' }}>
                                                            <span>{val.fileName}</span>
                                                        </div>
                                                        <a href={`${proxy.server}/${val.value}`}>
                                                            <Button color="info" >Download File</Button>
                                                        </a>
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </React.Fragment>
                )
        }
    }

    collapseUploadList = (index) => {
        let collapseUploadList = this.state.collapseUploadList;
        collapseUploadList[index] = !collapseUploadList[index];
        this.setState({ collapseUploadList: collapseUploadList })
    }

    handleDisplayImg = (src) => {
        let modal = document.getElementById("showImg");
        let modalImg = document.getElementById("imgContent");
        modal.style.display = "block";
        modalImg.src = src;
    }

    handleCloseDisplayImg = () => {
        let modal = document.getElementById("showImg");
        modal.style.display = "none";
    }


    render() {
        const { productData } = this.state;
        return (
            <React.Fragment>
                <Navbar nav={'Flim'} menu={'Film_DisplayProductImage'} />
                <div style={{ padding: '10px' }}>
                    <Card style={{ margin: '10px' }}>
                        <CardHeader><i class="fa fa-info-circle fa-lg" aria-hidden="true"></i> ข้อมูลสินค้า</CardHeader>
                        <CardBody>
                            <div style={{ padding: '10px' }}>
                                {
                                    productData && <ProductDetail productData={productData[0]} />
                                }
                            </div>
                        </CardBody>
                    </Card>
                    <Card style={{ margin: '10px' }}>
                        <CardHeader><i class="fa fa-cloud-upload fa-lg" aria-hidden="true"></i> รายการอัปโหลดไฟล์</CardHeader>
                        <CardBody>
                            <div style={{ padding: '10px' }}>
                                <Row>
                                    {
                                        this.state.uploadContent.map((val, i) => {
                                            return (
                                                <Card style={{ margin: '10px', width: '100%' }}>
                                                    <CardHeader style={{ backgroundColor: 'rgba(0,0,0,0)', cursor: 'pointer' }} onClick={() => this.collapseUploadList(i)}>
                                                        <div style={{ display: 'flex' }} >
                                                            <span style={{ flex: '1' }}  >{val.label} <Badge color="warning">{val.dataCount > 0 && val.dataCount}</Badge></span>
                                                            <span><i class="fa fa-minus-square-o" aria-hidden="true"></i></span>
                                                        </div>
                                                    </CardHeader>
                                                    <Collapse isOpen={this.state.collapseUploadList[i]}>
                                                        <CardBody><Col sm="12" md="12" style={{ padding: '5px' }} key={i}>
                                                            <Row>
                                                                <Col sm="12" md="12">
                                                                    {this.renderType(val.inputType, val.fieldName)}
                                                                </Col>
                                                            </Row>
                                                        </Col></CardBody>
                                                    </Collapse>
                                                </Card>
                                            )
                                        })
                                    }
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </div>
                <div id="showImg" className="modal">
                    <span className="close" onClick={() => this.handleCloseDisplayImg()} >&times;</span>
                    <img className="modal-content" id="imgContent" />
                </div>
            </React.Fragment>
        );
    }
}

export default Film_DisplayProductImage;

function ProductDetail(props) {
    return (
        <Row >
            <Col xs="12" sm="6" md="6" style={{ padding: '5px' }}>
                <Row>
                    <Col xs="12" sm="6" md="3" >Item Number: </Col>
                    <Col xs="12" sm="6" md="9" ><Input value={props.productData.itemId} disabled /></Col>
                </Row>
            </Col>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <Row style={{ display: 'flex' }}>
                    <Col xs="12" sm="6" md="3" >Product Name: </Col>
                    <Col xs="12" sm="6" md="9" ><Input value={props.productData.itemName} disabled /></Col>
                </Row>
            </Col>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <Row style={{ display: 'flex' }}>
                    <Col xs="12" sm="6" md="3" >IBrand 2: </Col>
                    <Col xs="12" sm="6" md="9" ><Input value={props.productData.ibrand2Desc} disabled /></Col>
                </Row>
            </Col>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <Row style={{ display: 'flex' }}>
                    <Col xs="12" sm="6" md="3" >IBrand 3: </Col>
                    <Col xs="12" sm="6" md="9" ><Input value={props.productData.ibrand3Desc} disabled /></Col>
                </Row>
            </Col>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <Row style={{ display: 'flex' }}>
                    <Col xs="12" sm="6" md="3" >Item G1: </Col>
                    <Col xs="12" sm="6" md="9" ><Input value={props.productData.itemG1Desc} disabled /></Col>
                </Row>
            </Col>
            <Col sm="6" md="6" style={{ padding: '5px' }}>
                <Row style={{ display: 'flex' }}>
                    <Col xs="12" sm="6" md="3" >Item G3: </Col>
                    <Col xs="12" sm="6" md="9" ><Input value={props.productData.itemG3Desc} disabled /></Col>
                </Row>
            </Col>
        </Row>
    )
}